/**
 * Debounce function - use like this:
 * var handler = debounce(function(){ do the work}, 100);
 * $(window).scroll(handler);
 * @param func callback function
 * @param wait time in milliseconds to wait
 * @param immediate
 */

type CallbackFunction = (...args: any[]) => any;

export function debounce<T extends CallbackFunction>(func: T, wait: number, immediate = false) {
    let timeout: number | null;

    return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
        /* eslint-disable @typescript-eslint/no-this-alias */
        const context = this;
        const later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout as number);
        timeout = window.setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
